import type { ResourceProps } from 'react-admin';
import DescriptionIcon from '@mui/icons-material/Description';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

export default {
  list: AsyncPageList as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: DescriptionIcon as ComponentType<any>,
} as ResourceProps;
